import type { InvoiceDTO, LedgerOperationDTO } from '@/shared/api'

/** Unix-секунды из Date в полночь по Москве (UTC+3). */
export const dayStartMsk = (date: Date): number =>
  Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 1000) - 3 * 3600

/** Конец московских суток выбранного дня (включительно). */
export const dayEndMsk = (date: Date): number => dayStartMsk(date) + 86400 - 1

/**
 * Суммы приходят строками (`'9500.00'`) — приводим к числу только для
 * форматирования и никогда не показываем сырую строку с точкой.
 */
export const formatMoney = (value: string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '—'
  const amount = Number(value.replace(',', '.'))
  if (Number.isNaN(amount)) return value
  return `${amount.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ₽`
}

export const invoiceNumberLabel = (invoice: InvoiceDTO): string =>
  invoice.number || `Счёт #${invoice.invoiceId}`

/** Счёт или заказ, к которому относится операция журнала. */
export const operationReference = (operation: LedgerOperationDTO): string => {
  if (operation.invoiceNumber) return `Счёт ${operation.invoiceNumber}`
  if (operation.invoiceId) return `Счёт #${operation.invoiceId}`
  if (operation.orderNumber) return `Заказ ${operation.orderNumber}`
  if (operation.shopOrderId) return `Заказ #${operation.shopOrderId}`
  return '—'
}
